import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import Spinner from "../components/Loader/Spinner";

import { allhostellogin } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "../api/constant";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import pdfLogo from "../images/login1.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const HostelReport = ({ role, userData }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [markRequired, setMarkRequired] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState("all");

  useEffect(() => {
    getData();
  }, []);

  // Update filteredData whenever rows or searchQuery changes
  useEffect(() => {
    const filtered = rows.filter(
      (item) =>
        item.school_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.amenities_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.amenities_sub_type_name
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        item.status.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchQuery, rows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let navigate = useNavigate();
  const view = (id) => {
    navigate(`/${role === 5 ? "dealer" : "admin"}/userdetails/${id}`);
  };

  const getData = () => {
    setIsLoading(true);
    let apiUrl = `/req_status_report/?UDISE_code=${userData.data.UDISE_code}&status=${status}`;

    axios
      .get(apiUrl)
      .then((response) => {
        if (response.data.status === "success") {
          console.log(response);
          setRows(response.data.data); // Update rows with the data array
        } else {
          setRows([]); // Set rows to an empty array if no data is available
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const exportPDF = () => {
    const doc = new jsPDF("landscape", "pt", "letter");

    const title = "SC/ST Department, Odisha";
    const reportName = "Requirement Status Report";
    const tableColumn = [
      "Sr. No.",
      "School Name",
      "Amenity Type",
      "Amenity Sub Type",
      "Proposed Quantity",
      "Modified Quantity",
      "Status",
    ];
    const tableRows = [];

    // Load your logo (replace 'path/to/your/logo.png' with actual path or base64 string)
    const logoUrl = pdfLogo; // Change this URL or use base64 image data
    doc.addImage(logoUrl, "PNG", 10, 10, 30, 30); // Adjust dimensions as needed

    // Calculate the center position for the title vertically with respect to the logo
    const titleHeight = 10 + 15; // Adjust this depending on your logo's height + some margin
    const titleRepHeight = 10 + 50;
    const titleWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
      const fromLeft = 330; // Adjust depending on the size and placement of your logo
      const fromRepLeft = 40;

    filteredData.forEach((row, index) => {
      const rowData = [
        index + 1,
        row.school_name,
        row.amenities_type,
        row.amenities_sub_type_name,
        row.proposed_quantity,
        row.modified_quantity,
        row.status,
      ];
      tableRows.push(rowData);
    });

    doc.setFontSize(16); // Sets the font size to 16 points for the title
    doc.text(title, fromLeft, titleHeight); // Position the title next to the logo
    doc.setFontSize(12);
    doc.text(reportName, fromRepLeft, titleRepHeight);
    doc.setFontSize(12); // Resets the font size for the table
    doc.autoTable(tableColumn, tableRows, { startY: 70 }); // Start the table 100px below the logo and title
    doc.save("requirement_status_report.pdf");
  };

  const exportExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Requirement Status Report");

    // Add title
    worksheet.mergeCells("A1:G1");
    const titleRow = worksheet.getRow(1);
    titleRow.getCell(1).value = "Requirement Status Report";
    titleRow.getCell(1).font = { bold: true, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: "center" };

    // Add headers
    const headers = [
      "Sr. No.",
      "School Name",
      "Amenity Type",
      "Amenity Sub Type",
      "Proposed Quantity",
      "Modified Quantity",
      "Status",
    ];
    // worksheet.addRow([]); // Add empty row for spacing
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "003366" }, // Blue background color
      };
      cell.font = {
        color: { argb: "FFFFFF" }, // White text color
        bold: true,
      };
    });

    // Add data
    filteredData.forEach((row, index) => {
      worksheet.addRow([
        index + 1,
        row.school_name,
        row.amenities_type,
        row.amenities_sub_type_name,
        parseInt(row.proposed_quantity),
        parseInt(row.modified_quantity),
        row.status,
      ]);
    });

    // Set workbook properties
    workbook.creator = "Your Name";
    workbook.lastModifiedBy = "Your Name";
    workbook.created = new Date();
    workbook.modified = new Date();

    // Generate Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const fileName = "requirement_status_report.xlsx";
      saveAs(blob, fileName);
    });
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4">{t("Requirement Status Report")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state with the new value
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px", // Additional style from your existing code
              }}
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div className="col-md-2 ">
            <label className="form-label" htmlfor="title">
              {t("Academic Year")}
            </label>
            <select
              name="district" // value={AssetsType}
              className="common-input form-select"
            >
              <option value="" selected={true}>
                {t("2023-24")}
              </option>
            </select>
          </div>
          <div className="col-md-2 " style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Status")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="year"
              className="common-input form-select"
              onChange={handleStatus}
              required
            >
              <option value="all">{t("Select Status")}</option>
              {/* {gcb.map((item) => (
                    <option value={item.id}>{t(item.type)}</option>
                    
                  ))} */}
              <option value="Completed">Completed</option>
              <option value="Rejected">Rejected</option>
              <option value="Pending">Pending</option>
            </select>
          </div>
          <button
            className="btn btn-primary btn-sm mx-5"
            style={{ marginTop: "35px", height: "30px" }}
            onClick={getData}
          >
            {t("Search")}
          </button>
        </div>

        <div class="col-md-12 mt-4 d-flex">
          <div class="d-flex justify-content-start align-items-center">
            <Button variant="contained" color="primary" onClick={exportPDF}>
              {t("Download PDF")}
            </Button>
            <span class="mx-2"></span>
            <Button variant="contained" color="success" onClick={exportExcel}>
              {t("Download Excel")}
            </Button>
          </div>
        </div>

        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("School Name")}</TableCell>
                  <TableCell align="left">{t("Amenity Type")}</TableCell>
                  <TableCell align="left">{t("Amenity Sub Type")}</TableCell>
                  <TableCell align="left">{t("Proposed Quantity")}</TableCell>
                  <TableCell align="left">{t("Modified Quantity")}</TableCell>
                  <TableCell align="left">{t("Status")}</TableCell>
                </TableRow>
              </TableHead>

              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {getSerialNumber(index)}
                        </TableCell>
                        <TableCell align="left">{row.school_name}</TableCell>
                        <TableCell align="left">{row.amenities_type}</TableCell>
                        <TableCell align="left">
                          {row.amenities_sub_type_name}
                        </TableCell>
                        <TableCell align="left">
                          {row.proposed_quantity}
                        </TableCell>
                        <TableCell align="left">
                          {row.modified_quantity}
                        </TableCell>
                        <TableCell align="left">{row.status}</TableCell>
                        {/* <TableCell align="left"><button className='btn btn-success btn-sm' onClick={() => view(row.party_code)}>{t('View')}</button></TableCell> */}
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default HostelReport;
